import { makeStyles } from "@material-ui/core/styles";
import commonStyles from "../../../theme/common.styles";

const useStyles = makeStyles((theme) => ({
  confirmDialogWrapper: {
    width: "100%",
    padding: 24,
    position: "relative",
    minWidth: 312,
    maxWidth: 340,
  },
  closeBtn: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    cursor: "pointer",

    "& svg": {
      fill: theme.palette.baseColor,
      height: 18,
      width: 18,
    },
  },
  confirmButton: {
    color: theme.palette.blackColor,
    fontSize: 16,
    fontWeight: 600,
    marginLeft: 32,
    marginTop: 16,
    cursor: "pointer",
    "&:last-child": {
      paddingRight: 0,
    },
  },
  greenText: {
    color: "#108640",
  },
  popupContent: {
    textAlign: "center",
    "& h4": {
      fontSize: 20,
      fontWeight: 700,
      margin: "16px 0",
      letterSpacing: "0.1px",
      color: theme.palette.baseColor,
    },
    "& p": {
      fontSize: 16,
      fontWeight: 600,
      lineHeight: "16px",
      marginBottom: 12,
      whiteSpace: "pre-wrap",
      color: theme.palette.baseColor,
      letterSpacing: "0.25px",
    },
  },
  icon: {
    lineHeight: 1,
    fontSize: 24,
    "& svg": {
      fill: "#4caf50",
      width:"42px",
      height:"42px"
    },
  },
  btnContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
  },
}));

export default useStyles;
